// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__rpwmS","button":"index_button__h_jFw","btn-hold":"index_btn-hold__hGwrl","btn-hold-text":"index_btn-hold-text__70hqE"};